import { Schema as S } from "effect";

import { Avatar } from "./common";
import { Entry } from "./entries";
import { RecordSummary } from "./records";

export const UsageMetric = S.Struct({
	metric: S.String,
	current: S.Number,
	limit: S.Number,
	period: S.String,
});
export type UsageMetric = typeof UsageMetric.Type;

export const UsageSummary = S.Struct({ metrics: S.Array(UsageMetric) });
export type UsageSummary = typeof UsageSummary.Type;

export const UsageExport = S.Struct({
	exportedAt: S.String,
	nodes: S.Array(
		S.Struct({
			...RecordSummary.fields,
			externalId: S.Record(S.String, S.String),
			avatar: Avatar,
		}),
	),
	knots: S.Array(
		S.Struct({ ...Entry.fields, externalId: S.Record(S.String, S.String) }),
	),
});
export type UsageExport = typeof UsageExport.Type;
